import type { LeaderboardRecord } from "@memorang/types";

type Response = {
	leaderboard: LeaderboardRecord[];
};

const fetchLeaderboard = async (
	_tenantId: string,
	_scope: string,
): Promise<Response> => {
	return {
		leaderboard: [],
	};
};

export default fetchLeaderboard;
